import { ILocation } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
	update: {
		name?: string
		note?: string
	}
}

export async function locationUpdateApi(payload: RequestDataShape, token: string) {
	const endpoint = "/location/update/v1"
	const requester = new ApiRequester<RequestDataShape, ILocation>(endpoint)
	const response = await requester.sendRequest(payload, token)
	return response
}
